export const transformTextToHexFormat = (color) => {
  if (color === undefined || color === null) return ''

  const upperCaseColor = color?.toUpperCase()

  if (color?.charAt(0) === '#') {
    return upperCaseColor
  } else {
    return `#${upperCaseColor}`
  }
}
